export const dataURItoBlob = (dataURI: string) => {
  const byteString = atob(dataURI.split(',')[1]);
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], { type: mimeString });
};

export const getFilePreview = (file: File | Blob | null): any => {
  return new Promise((resolve) => {
    if (!file) {
      resolve({
        fileName: null,
        preview: null,
        blob: null,
      });
      return;
    }

    const reader = new FileReader();

    reader.onload = (data: any) => {
      resolve({
        fileName: (file as any).name || 'image.jpg',
        preview: data.target.result,
        blob: dataURItoBlob(data.target.result),
      });
    };

    reader.readAsDataURL(file);
  });
};
